import { ComboPessoaFisica } from './combo-pessoa-fisica';

export class FilterPessoaFisica {
	pessoaFisica: ComboPessoaFisica;
}